/*
 * @Author: your name
 * @Date: 2021-02-23 14:01:56
 * @LastEditTime: 2022-01-12 11:24:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /sunyur/fe-mall/pages/index/src/router/setting.js
 */
export default {
  fluid: [
    // 系统设置 - 个人信息
    {
      path: '/setting/personal',
      name: 'personal',
      component: () => import(/* webpackChunkName: "personal" */'../routes/setting/personal/index.vue'),
      meta: {
        // title: '个人信息',
        title: {
          'zh-CN': '个人信息',
          en: '个人信息_en',
          jp: '个人信息_jp'
        },
        spmB: 'b28',
        isNewHeader: true,
        i18nCode: 'setting/personal'
      }
    },
    // 系统设置 - 密码修改
    {
      path: '/setting/password',
      name: 'password',
      component: () => import(/* webpackChunkName: "password" */'../routes/setting/password/index.vue'),
      meta: {
        // title: '密码修改',
        title: {
          'zh-CN': '密码修改',
          en: '密码修改_en',
          jp: '密码修改_jp'
        },
        spmB: 'b29',
        isNewHeader: true,
        i18nCode: 'setting/password'
      }
    },
    // 系统设置 - 收货地址
    {
      path: '/setting/address',
      name: 'address',
      component: () => import(/* webpackChunkName: "address" */'../routes/setting/address/index.vue'),
      meta: {
        // title: '收货地址',
        title: {
          'zh-CN': '地址管理',
          en: '地址管理_en',
          jp: '地址管理_jp'
        },
        spmB: 'b30',
        loginCheck: false,
        isNewHeader: true,
        i18nCode: 'setting/address'
      }
    }
  ]
}
